import React, { Component } from 'react';
import { Redirect } from "react-router-dom";
import api from "../api/index.js";

import './loginrequired.scss';

class Login extends Component {
	constructor(props) {
		super(props);
		this.loggedOut = this.loggedOut.bind(this);
		this.loggedIn = this.loggedIn.bind(this);
		this.state = {
			loggedIn: api.auth.isLoggedIn(),
		};
	}

	loggedOut(data) {
		console.log("Logged out");
		this.setState({loggedIn: false});
	}
	
	loggedIn(data) {
		console.log("Logged in", data);
		console.log(this);
		this.setState({loggedIn: true});
	}
	
	componentDidMount() {
		api.auth.addEventListener('loggedOut', this.loggedOut);
		api.auth.addEventListener('loggedIn', this.loggedIn);
		this.setState({loggedIn: api.auth.isLoggedIn()});
	}
	
	componentWillUnmount() {
		api.auth.removeEventListener('loggedOut', this.loggedOut);
		api.auth.removeEventListener('loggedIn', this.loggedIn);
		
	}
	
	render() {
		if (this.state.loggedIn) 
			return <div>{this.props.children}</div>;
		else 
			return <div className="loginpls">Please sign in.<Redirect to="/" /></div>;
	}
}

export default Login;
